<div class="payment-wrapper payment-error-wrapper">
  <div class="payment-status-icon">
    <img [src]="sanitizing.bypassSecurityTrustUrl(helperService.paymentStatusesIcons['FAILED'])" alt="error" />
  </div>
  <div class="payment-status-title">{{ 'payment.error_title' | translate }}</div>
  <!--  <div class="payment-status-description">Lorem ipsum</div>-->
  <button class="btn btn-secondary btn-block payment-status-btn" (click)="onRetry()">
    <span class="icon-reload"></span>{{ 'retry_btn' | translate }}
  </button>
</div>
